<!-- Change Password Modal  -->
<p-dialog
  [visible]="changePasswordModal()"
  [resizable]="false"
  [modal]="true"
  (onHide)="ClosePopup()"
  [breakpoints]="{ '991px': '100vw' }"
  [style]="{ width: '960px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="formGroup" (ngSubmit)="ValidateAndSubmit()">
      <!-- Header -->
      <div
        class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <div class="flex align-items-center">
          <h2 class="mb-0 text-sm">
            {{ 'STAFF.CHANGEPASSWORD.HEADER_CHANGE_PASSWORD_FOR' | translate }}
            <strong>{{ staff().name }}</strong>
            <span class="text-xs text-600"> - {{ staff().id }}</span>
          </h2>
        </div>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="ClosePopup()"
        ></div>
      </div>
      <!-- Header -->
      <!-- Content -->
      <div class="flex">
        <!-- Left Side-->
        <div class="border-right-1 border-300 lg:w-6 w-full">
          <!-- Modal Content -->
          <div class="py-2 md:py-4 px-3 md:px-5 surface-100">
            <!-- Column -->
            <div class="mb-3 md:mb-4 lg:w-11">
              <h4 class="font-medium text-700 text-xs mb-2 block uppercase">
                {{ 'STAFF.CHANGEPASSWORD.HEADER_NEW_PASSWORD' | translate }}
              </h4>
              <p-password
                [toggleMask]="true"
                formControlName="new_password"
                styleClass="w-full p-input-icon-right"
                [strongRegex]="'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})'"
              />
              @if (NewPassword.touched && NewPassword.invalid) {
                <app-error-msg
                  [errors]="NewPassword.errors"
                  [fieldLabel]="'STAFF.CHANGEPASSWORD.NEW_PASSWORD' | translate"
                />
              }
              @if (NewPassword.errors?.['confirmedValidator']) {
                <div class="required" class="p-error text-xs mb-0">
                  <div class="p-error mt-1 validationerror">
                    {{
                      'common.errors.validations.PASSWORD_MISMATCH' | translate
                    }}
                  </div>
                </div>
              }
            </div>
            <!-- Column -->
            <!-- Column -->
            <div class="lg:w-11">
              <h4 class="font-medium text-700 text-xs mb-2 block uppercase">
                {{
                  'STAFF.CHANGEPASSWORD.HEADER_CONFIRM_NEW_PASSWORD' | translate
                }}
              </h4>
              <p-password
                [toggleMask]="true"
                formControlName="new_confirm_password"
                styleClass="w-full p-input-icon-right"
                [strongRegex]="'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})'"
              />
              @if (NewConfirmPassword.touched && NewConfirmPassword.invalid) {
                <app-error-msg
                  [errors]="NewConfirmPassword.errors"
                  [fieldLabel]="
                    'STAFF.CHANGEPASSWORD.NEW_CONFIRM_PASSWORD' | translate
                  "
                />
              }
              @if (NewConfirmPassword.errors?.['confirmedValidator']) {
                <div class="required" class="p-error text-xs mb-0">
                  <div class="p-error mt-1 validationerror">
                    {{
                      'common.errors.validations.PASSWORD_MISMATCH' | translate
                    }}
                  </div>
                </div>
              }
            </div>
            <!-- Column -->
          </div>
          <!-- Modal Content -->
          <!-- Password Rules -->
          <div class="lg:px-5 px-3 py-3 border-top-1 border-400 surface-0">
            <ul class="list-none p-0 m-0 text-sm">
              <li class="flex align-items-center py-2">
                <i class="fa fa-check text-600"></i>
                <span class="ml-3 text-sm md:text-base">
                  {{ 'STAFF.CHANGEPASSWORD.SPAN_ATLEAST8CHARLONG' | translate }}
                </span>
              </li>
              <li class="flex align-items-center py-2">
                <i class="fa fa-check text-600"></i>
                <span class="ml-3 text-sm md:text-base">
                  {{ 'STAFF.CHANGEPASSWORD.SPAN_ONELOWERCHAR' | translate }}
                </span>
              </li>
              <li class="flex align-items-center py-2">
                <i class="fa fa-check text-600"></i>
                <span class="ml-3 text-sm md:text-base">
                  {{ 'STAFF.CHANGEPASSWORD.SPAN_ONEUPPERCHAR' | translate }}
                </span>
              </li>
              <li class="flex align-items-center py-2">
                <i class="fa fa-check text-600"></i>
                <span class="ml-3 text-sm md:text-base">
                  {{ 'STAFF.CHANGEPASSWORD.SPAN_SPECIALCHAR' | translate }}
                </span>
              </li>
            </ul>
          </div>
          <!-- Password Rules -->
          <!-- Modal Footer -->
          <div class="lg:px-4 px-2 py-3 border-top-1 border-400 surface-0">
            <div class="flex align-items-center justify-content-between">
              <div class="w-4">
                <p-button
                  [label]="'STAFF.CHANGEPASSWORD.CANCEL' | translate"
                  styleClass="text-sm p-button-link"
                  (click)="ClosePopup()"
                />
              </div>
              <div class="w-8 text-right">
                <button
                  type="submit"
                  pButton
                  pRipple
                  [label]="'STAFF.CHANGEPASSWORD.RESETPASSWORD' | translate"
                  class="text-sm"
                ></button>
              </div>
            </div>
          </div>
          <!-- Modal Footer -->
        </div>
        <!-- Left Side -->
        <!-- Right Side -->
        <div
          class="pl-3 w-6 hidden lg:flex align-items-center justify-content-center p-3 text-right"
        >
          <img src="/assets/img/change-pwd-img.svg" alt="Image" />
        </div>
        <!-- Right Side -->
      </div>
      <!-- Content -->
    </form>
  </ng-template>
</p-dialog>
<!-- Change Password Modal -->
<!-- </ng-container> -->

<!-- Confirm Delete Profile Modal  -->
@if (showErrorPopup | async; as show_Popup) {
  <app-errors
    [visible]="show_Popup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [errorData]="errorMessages"
    [error]="error"
    (hideErrorPopup)="HideErrorPopup($event)"
  />
}

<!-- Confirm Delete Profile Modal -->
